import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchVisaDirectPushTransaction from '../../../../hooks/useApi/useFetchVisaDirectPushTransaction';
import VisaDirectPushTransactionInfo from './VisaDirectPushTransactionInfo';

type FC = FunctionComponent<vp.TransactionId>;

const VisaDirectPushTransactionContainer: FC = (props: vp.TransactionId) => {
  const { TransactionID } = props;
  const [visaDirectPushTransaction, getVisaDirectPushTransaction] = useFetchVisaDirectPushTransaction({});
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.VisaDirectPushTransactionResponse>();

  useEffect(() => {
    getVisaDirectPushTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (visaDirectPushTransaction) {
      setTransaction(visaDirectPushTransaction);
    }
  }, [visaDirectPushTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <VisaDirectPushTransactionInfo transaction={transaction} />}</div>;
};

export default VisaDirectPushTransactionContainer;
